import { render, staticRenderFns } from "./ProductsHead.vue?vue&type=template&id=fe0a262a&scoped=true"
import script from "./ProductsHead.vue?vue&type=script&lang=js"
export * from "./ProductsHead.vue?vue&type=script&lang=js"
import style0 from "./ProductsHead.vue?vue&type=style&index=0&id=fe0a262a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0a262a",
  null
  
)

export default component.exports